/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";

import { Text } from "UpduoLibrary";
import { skaleWebTextGray } from "config/UpduoColors";

export default function PlaceholderView() {
  // Placeholder component, used when no active skills exist
  return (
    <Text
      style={{
        fontWeight: "bold",
        color: skaleWebTextGray,
        marginBottom: 15,
        marginLeft: 20,
      }}
    >
      {"No active lessons found. Please create a new lesson."}
    </Text>
  );
}
